import React from 'react'

const GameLoadingDisplay = () => {
  return (
    <div className='my-5'>
      <h3 className='text-dark h1'>Loading...</h3>
      {/* <h3 className='text-dark pt-3'>Game Will Start In:</h3>
      <div className='text-primary display-2 fw-bolder mt-3'>3</div> */}
    </div>
  )
}

export default GameLoadingDisplay